// Floating Text Data
const pi = Math.PI;
export const floatingTextData = [
    {
        text: "Welcome to my Portfolio!",
        position: [0, -4, 1], 
        fontSize: 0.2,
        color: "white",
        rotation: [0, pi, 0]
    },
    {
        text: "Me",
        position: [-5, -5.5, 7.2],
        fontSize: 0.2,
        color: "white",
        rotation: [0.1, pi * 180 / 2 * pi, .10]
    },
];

export const floatingTextData2D = [
    {
        text: "Hey There!",
        position: [-17, -3.56, -15.8], 
        fontSize: 0.3,
        color: "white",
        rotation: [0, pi, 0]
    }
]